import * as actions from './actions'
import * as selectors from '../Reports/selectors'
import * as resourceSelectorActions from '../ResourceSelector/actions'
import { connect } from 'react-redux'
import { AppState, Dispatch } from '../../types'
import { EventProps, ExternalProps, Props, ReportsPage } from './ReportsPage'
import { ResourceSelectorContainer } from '../ResourceSelector/model'
import { selectors as authSelectors } from '../../lifecycle/auth'
import MonitoringLocalStorageManager from '../../util/storage/MonitoringLocalStorageManager'

const mapProps = (state: AppState, ownProps: ExternalProps): Props => ({
  ...ownProps,
  labels: state.monitoring.labels.resources,
  isLoading: selectors.getIsLoading(state),
  organizationId: authSelectors.getOrganizationId(state),
  environments: selectors.getAllEnvironments(state),
  environmentsLoading: selectors.getEnvironmentsLoading(state),
  selectedType: ownProps.selectedType || selectors.getSelectedType(state),
  applicationsData: selectors.getApplicationsData(state),
  applications: selectors.getAllApplications(state),
  applicationsARM: selectors.getAllApplicationsARM(state),
  reportsApplications: selectors.getAllReportsApplications(state),
  allBusinessGroupEnabled: window.mc.featureFlags.reports.allBusinessGroups.enabled === 'true'
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  initializeLoading: () =>
    dispatch(actions.initializeLoading()),
  changeSelectedType: (selectedType: string) =>
    dispatch(actions.changeSelectedType(selectedType)),
  fetchApplicationsData: (organizationId: string, envId: string, selectedType: string, dateRange: any) =>
    dispatch(actions.fetchApplicationsData(organizationId, envId, selectedType, dateRange)),
  selectApplication: (appId: string) =>
    dispatch(resourceSelectorActions.changeSelectedApplication(appId)),
  fetchApplications: (businessGroup: string, environment: string) =>
    dispatch(actions.fetchApplications(businessGroup, environment)),
  fetchApplicationsARM: (businessGroup: string, environment: string) =>
    dispatch(actions.fetchApplicationsARM(businessGroup, environment)),
  fetchEnvironments: (resourceSelectorContainer: ResourceSelectorContainer) =>
    dispatch(resourceSelectorActions.fetchEnvironments(resourceSelectorContainer)),
  selectEnvironment: (resourceSelectorContainer: ResourceSelectorContainer) =>
    dispatch(resourceSelectorActions.selectEnvironments(resourceSelectorContainer)),
  changeDateRange: (dateRange: any) => dispatch(actions.changeDateRange(dateRange)),
  handleWrongOrgOrEnv: () => {
    MonitoringLocalStorageManager.remove('reports')
    window.location.hash = '#/reports'
  }
})

export default connect(mapProps, mapDispatch)(ReportsPage)
